'use client';
import "@/assets/css/products.css";
import Link from "next/link";
import HeaderProduct from "@/Components/HeaderProduct/HeaderProduct";
import GetDetailsPart from "@/product/[id]/Components/GetDetailsPart";
import Gallery from "@/product/[id]/Components/Gallery/Gallery";
import SolutionProducts from "@/solution/[id]/SolutionProducts";
import { useKit } from "./kit-context";
import StructuredData from "@/Components/StructuredData/StructuredData";
import { buildBreadcrumbSchema, buildProductSchema } from "@/lib/structured-data";
import styles from "./page.module.css";

export default function KitPage() {
    const { kit, kitProducts } = useKit();

    if (!kit) {
        return <p className="text-danger my-5">Failed to load kit details.</p>;
    }

    const details = Array.isArray(kit.details) ? kit.details : [];

    return (
        <div>
            <StructuredData
                data={[
                    buildBreadcrumbSchema([
                        { name: "Home", path: "/" },
                        { name: "Kits", path: "/solution/custom#solution-content" },
                        { name: kit.name, path: `/kit/${kit.alt_id}` },
                    ]),
                    buildProductSchema(kit),
                ]}
            />
            <HeaderProduct product={kit} />

            <div className={`ux-container ${styles.kitPageContent}`}>
                <h1 className="my-4">{kit.name}</h1>
                <div className="row mb-5">
                    <div className={`${kit.media && kit.media.length ? "col-12 col-md-4 mb-3" : "d-none"}`}>
                        <div className="sticky">
                            <h4 className="spotlight-product-heading">{kit.name}</h4>
                            <hr className="heading-content-divider"/>
                            <Gallery media={kit.media} productName={kit.name} />
                        </div>
                    </div>
                    <div className={`testing-focus ${kit.media && kit.media.length ? "col-12 col-md-8" : "col-12"}`}>
                        <GetDetailsPart
                            determinant="DESCRIPTION"
                            details={details}
                            characterAmount="0"
                            showHeading={true}
                        />
                    </div>
                </div>

                {details.slice(2).map((detail) => (
                    <div key={detail.id} className="bm-5 mt-5">
                        <div dangerouslySetInnerHTML={{ __html: detail.text }} />
                        <div className="mb-5"/>
                    </div>
                ))}

                {kitProducts.length > 0 && (
                    <>
                        <h2 className={styles.kitProductsTitle}>Included Products</h2>
                        <SolutionProducts products={kitProducts} />
                    </>
                )}

                <section className={styles.otherKits}>
                    <h2 className={styles.otherKitsTitle}>See Other Options/Kits</h2>
                    <Link href="/solution/custom#solution-content" className="btn btn-outline-primary">
                        Back to Kits
                    </Link>
                </section>
            </div>
        </div>
    );
}
